import { withErrorBoundary } from "@sentry/nextjs";
import cn from "classnames";
import React, { VFC } from "react";
import styled from "styled-components";
import { useTransition } from "hooks";

interface Props {
  className?: string;
  errorMessage?: string;
  id: string;
  isValid?: boolean;
  name?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void; // eslint-disable-line no-unused-vars
  placeholder?: string;
  value: string;
}

const Input: VFC<Props> = withErrorBoundary(
  ({ className = "", errorMessage = "", id, isValid = true, name = "", onChange, placeholder = "", value }) => {
    const { isLiving: isLivingErrorMessage, isDisplay: isDisplayErrorMessage } = useTransition(!isValid, 200);

    return (
      <StyledInput
        className={cn(className, {
          Input_isInvalid: !isValid,
        })}
      >
        <div className="Input__innerContainer">
          <input
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={cn("Input__input Font_16_22_450", {
              Color_primary: value,
            })}
            id={id}
            name={name}
          />
        </div>

        {isLivingErrorMessage && (
          <p
            className={cn("Input__errorMessage Font_14_20_450", {
              Input__errorMessage_isDisplay: isDisplayErrorMessage,
            })}
          >
            {errorMessage}
          </p>
        )}
      </StyledInput>
    );
  },
  {}
);

const StyledInput = styled.div`
  .Input__innerContainer {
    position: relative;
  }

  .Input__input {
    width: 100%;
    appearance: none;
    padding: 13px 16px;
    border-radius: 4px;
    border: none;
    background-color: ${({ theme }) => theme.colors.fog["00"]};
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.fog["30"]};
  }

  .Input__input::placeholder {
    color: ${({ theme }) => theme.colors.subdued};
  }

  .Input__errorMessage {
    opacity: 0;
    margin-top: -20px;
    color: ${({ theme }) => theme.colors.ember["70"]};
    transition: 0.2s;
  }

  .Input__errorMessage_isDisplay {
    opacity: 1;
    margin-top: 4px;
  }

  &.Input_isInvalid {
    .Input__input {
      box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.ember["30"]};
    }
  }
`;

export { Input };
